import { t } from '@trimble/i18n';
import { TreeNodeDefinition } from '@trimble/ui-components/solidjs';
import { CrsIssueKind } from '@trimble/project-data-panel-types';
import { UnreachableCaseError } from 'ts-essentials';

export function mapCrsIssueToTreeNodeStatus(
  crsIssue: CrsIssueKind | undefined
): TreeNodeDefinition['status'] {
  if (crsIssue === undefined) {
    return undefined;
  }
  switch (crsIssue) {
    case 'missing':
      return { message: t('mobileMapping.projectData.pointCloudMissingCrs') };
    case 'mismatch':
      return { message: t('mobileMapping.projectData.crsMismatch') };
    default:
      throw new UnreachableCaseError(crsIssue);
  }
}
